import { useEffect, useRef, useState } from "react";

export const Cursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);
  const [label, setLabel] = useState("");
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.documentElement.classList.add("has-custom-cursor");
    const pos = { x: -100, y: -100 };
    const ringPos = { x: -100, y: -100 };
    let raf;

    const move = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
    };
    const loop = () => {
      ringPos.x += (pos.x - ringPos.x) * 0.16;
      ringPos.y += (pos.y - ringPos.y) * 0.16;
      if (dot.current) dot.current.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)`;
      if (ring.current) ring.current.style.transform = `translate(${ringPos.x}px, ${ringPos.y}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    const over = (e) => {
      const view = e.target.closest('[data-cursor="view"]');
      const interactive = e.target.closest("a, button, input, select, textarea, [role='button']");
      setLabel(view ? "Ansehen" : "");
      if (ring.current) {
        ring.current.classList.toggle("cursor-view", !!view);
        ring.current.classList.toggle("cursor-active", !!interactive && !view);
      }
    };

    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("has-custom-cursor");
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div ref={ring} className="custom-cursor-ring" data-testid="custom-cursor" aria-hidden="true">
        {label && <span>{label}</span>}
      </div>
      <div ref={dot} className="custom-cursor-dot" aria-hidden="true" />
    </>
  );
};
